import type { TenantContext } from './auth';

// Aligned with wire OrgSettings from @jobmate/types (Issue #67)
export interface OrgSettings {
  orgId: number;
  slug: string;
  name: string;
  logoUrl?: string;
  colorScheme?: string;
  timeZone?: string;
  locale?: string;
  customSettings?: Record<string, unknown>;
}

export interface OrgSettingsInput {
  name?: string;
  logo?: File;
  colorScheme?: string;
}

export enum InviteStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export interface OrgUser {
  id: number; // wire User.id is number — Issue #67
  email: string;
  name: string;
  role: TenantContext['role'];
  inviteStatus: InviteStatus;
  joinedAt: string | null;
}
